import { Button, Typography } from "@mui/material";
import { useAuth } from "@poseidon/ui/components/AuthContext";
import { StackedContainer } from "@poseidon/ui/styles/layout";
import { Link } from "react-router-dom";
import { AccountCircle } from "@mui/icons-material";
import { Avatar } from "@mui/material";

export default function DealerProfile() {
  const { user, signOut, profile } = useAuth();

  return (
    <StackedContainer>
      <Typography variant="h3">Account</Typography>
      <Link to="/profile">
        <Avatar
          sx={{
            height: 135,
            width: 135,
            my: 4,
          }}
          src="/static/images/avatars/avatar_1.png"
        >
          <AccountCircle style={{ transform: "scale(4)" }} />
        </Avatar>
      </Link>
      <Typography variant="h6">{user.email}</Typography>
      <br />
      <Typography>Company Name: {profile.companyName}</Typography>
      <br />
      <Typography>Company Number: {profile.companyNumber}</Typography>
      <br />
      <Typography>
        Company Address:
        <br />
        {profile.address}
        <br />
        {profile.postcode}
      </Typography>
      <br />
      <Button variant="contained" onClick={() => signOut()}>
        Log Out
      </Button>
    </StackedContainer>
  );
}
